module.exports = __webpack_public_path__ + "img/4.0acb3e19.jpg";